/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactLieuFormationGridDto } from './ContactLieuFormationGridDto';
import {
    ContactLieuFormationGridDtoFromJSON,
    ContactLieuFormationGridDtoFromJSONTyped,
    ContactLieuFormationGridDtoToJSON,
} from './ContactLieuFormationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactLieuFormationGridDtoPaginatedResults
 */
export interface ContactLieuFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactLieuFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactLieuFormationGridDto>}
     * @memberof ContactLieuFormationGridDtoPaginatedResults
     */
    results?: Array<ContactLieuFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactLieuFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactLieuFormationGridDtoPaginatedResults interface.
 */
export function instanceOfContactLieuFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactLieuFormationGridDtoPaginatedResultsFromJSON(json: any): ContactLieuFormationGridDtoPaginatedResults {
    return ContactLieuFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactLieuFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactLieuFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactLieuFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactLieuFormationGridDtoPaginatedResultsToJSON(value?: ContactLieuFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactLieuFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

